module.exports = __webpack_public_path__ + "5ff9a9c665fec3ce21b2c20425c94eca.pdf";